import { APP_DOMAIN, BASE_URL } from "~/constants/common";
import { getRuntimeEnv } from "~/utils/getRuntimeEnv";

// The origin a link meant for other sites should carry: the configured public
// site, never whichever host this page happens to be open on.
export const getPublicSiteOrigin = (): string =>
  getRuntimeEnv()?.VITE_BASE_URL?.trim().replace(/\/$/, "") || APP_DOMAIN;

export const getSiteOrigin = (url?: string | null): string => {
  if (url) {
    try {
      return new URL(url).origin;
    } catch {
      // ignore invalid URLs
    }
  }

  const baseUrl = BASE_URL?.replace(/\/$/, "");
  return baseUrl || APP_DOMAIN;
};
